module.exports = __webpack_public_path__ + "static/media/tarot-card-6.2dabb1c7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/mobioastro/assets/images/tarotcards/tarot-card-6.jpg
// module id = 146
// module chunks = 0